import React from 'react';
import './GenAISection.css';

const GenAISection = () => {

  return (
    <section className="genai-container">
      <div className="genai-content">
        <div className="genai-section">
          <div className="genai-text">
            <h2 className="genai-title">As a Senior Data Scientist</h2>
            <div className="genai-description">
              <p>
                I design and develop AI-powered systems that solve complex, real-world business problems. Over the past several years, I have worked across Generative AI, with LLMs, Agentic AI, Computer Vision, Intelligent Document Processing, and Natural Language Processing, building solutions that move from research and experimentation into production.
              </p>
              <p>
                My experience spans developing multi-agent workflows, Retrieval-Augmented Generation (RAG) applications, conversational AI systems, intelligent document processing pipelines, and computer vision solutions for enterprise clients across pharmaceuticals, customer service, and business operations. More recently, I have been focused on designing AI-driven workflow automation systems that leverage agent orchestration, evaluation frameworks, and personalized content generation to support customer engagement and business growth at scale. I have built scalable AI products using technologies such as LangGraph, Crew AI, Arize and Azure AI Services, with a strong emphasis on reliability, observability, and measurable business impact.
              </p>
              <p>
                I enjoy transforming complex data and emerging AI technologies into practical solutions that deliver real value. My passion lies in bridging the gap between cutting-edge AI capabilities and the business challenges they are designed to solve.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GenAISection; 